/* S-thetics PDP LP — interactions */
(function () {
  if (window.__pdpInit) return;
  window.__pdpInit = true;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    // Gallery thumb swap
    document.querySelectorAll('.pdp-gallery-thumbs').forEach(function (group) {
      var main = group.parentElement.querySelector('.pdp-gallery-main img');
      group.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var src = b.getAttribute('data-src');
          if (src && main) main.src = src;
          group.querySelectorAll('button').forEach(function (x) { x.classList.remove('active'); });
          b.classList.add('active');
        });
      });
    });

    // ---------------------------------------------------------------------
    // Variant selection.
    //
    // The pills used to only toggle a CSS class while the cart form held a
    // single variant id fixed at render time, so every flavour added the first
    // variant to the cart. Selection now resolves against the product's real
    // variants and drives the form, the price, availability and the image.
    // ---------------------------------------------------------------------
    var variantData = null;
    var dataEl = document.getElementById('pdp-variant-data');
    if (dataEl) {
      try { variantData = JSON.parse(dataEl.textContent); } catch (e) { variantData = null; }
    }

    var priceDisplay = document.getElementById('pdp-priceDisplay');
    var variantInput = document.getElementById('pdp-variantId');
    var planInput = document.getElementById('pdp-sellingPlan');
    var atcButton = document.getElementById('pdp-atc');
    var mainImage = document.getElementById('pdp-mainImage');
    var poGroup = document.querySelector('.pdp-purchase-options');

    function selectedOptions() {
      var values = [];
      document.querySelectorAll('.pdp-option-group[data-option-index]').forEach(function (group) {
        var index = parseInt(group.getAttribute('data-option-index'), 10);
        var active = group.querySelector('.pdp-pill.active');
        if (active) values[index] = active.getAttribute('data-option-value');
      });
      return values;
    }

    function findVariant(values) {
      if (!variantData) return null;
      return variantData.variants.filter(function (v) {
        return v.options.every(function (opt, i) { return opt === values[i]; });
      })[0] || null;
    }

    // A value is offered when some available variant carries it alongside the
    // current selection for the *other* options.
    function refreshPillAvailability(values) {
      if (!variantData) return;
      document.querySelectorAll('.pdp-option-group[data-option-index]').forEach(function (group) {
        var index = parseInt(group.getAttribute('data-option-index'), 10);
        group.querySelectorAll('.pdp-pill').forEach(function (pill) {
          var candidate = values.slice();
          candidate[index] = pill.getAttribute('data-option-value');
          var reachable = variantData.variants.some(function (v) {
            if (!v.available) return false;
            return v.options.every(function (opt, i) {
              return i === index ? opt === candidate[index] : (values[i] === undefined || opt === values[i]);
            });
          });
          pill.classList.toggle('soldout', !reachable);
        });
      });
    }

    // Subscription options only make sense for a variant that actually has a
    // selling plan. Mommy Power has one; the other products have none, yet all
    // four pages advertise the same "Abonnieren & sparen" tier.
    function refreshPurchaseOptions(variant) {
      if (!poGroup) return;
      var plans = (variant && variant.sellingPlans) || [];
      var options = Array.prototype.slice.call(poGroup.querySelectorAll('.pdp-po-option'));
      var fallback = null;
      var selectedWasDisabled = false;

      options.forEach(function (el) {
        var isSubscription = el.getAttribute('data-is-subscription') === 'true';
        var usable = !isSubscription || plans.length > 0;
        el.hidden = !usable;
        el.classList.toggle('unavailable', !usable);
        if (isSubscription && usable && !el.getAttribute('data-selling-plan')) {
          el.setAttribute('data-selling-plan', String(plans[0]));
        }
        if (usable && !fallback) fallback = el;
        if (!usable && el.classList.contains('selected')) selectedWasDisabled = true;
      });

      if (selectedWasDisabled && fallback) applyPurchaseOption(fallback);
      else {
        var current = poGroup.querySelector('.pdp-po-option.selected');
        if (current) syncSellingPlan(current, plans);
      }
    }

    function syncSellingPlan(el, plans) {
      if (!planInput) return;
      var isSubscription = el.getAttribute('data-is-subscription') === 'true';
      if (!isSubscription) { planInput.value = ''; return; }
      var plan = el.getAttribute('data-selling-plan') || (plans && plans[0]) || '';
      planInput.value = plan ? String(plan) : '';
    }

    function applyPurchaseOption(el) {
      if (!poGroup) return;
      poGroup.querySelectorAll('.pdp-po-option').forEach(function (x) { x.classList.remove('selected'); });
      el.classList.add('selected');
      var price = el.getAttribute('data-price');
      if (price && priceDisplay) priceDisplay.textContent = price;
      var variant = findVariant(selectedOptions());
      syncSellingPlan(el, (variant && variant.sellingPlans) || []);
    }

    function applyVariant(variant) {
      if (variantInput && variant) variantInput.value = String(variant.id);

      if (atcButton) {
        var available = !!(variant && variant.available);
        atcButton.disabled = !available;
        var label = available
          ? atcButton.getAttribute('data-label-available')
          : atcButton.getAttribute('data-label-soldout');
        if (label) atcButton.textContent = label;
      }

      // The purchase-option tiers own the headline price when they exist,
      // since they encode the subscription discount. Fall back to the real
      // variant price otherwise.
      if (priceDisplay && variant) {
        var selectedPo = poGroup && poGroup.querySelector('.pdp-po-option.selected:not([hidden])');
        if (!selectedPo) priceDisplay.textContent = variant.price;
      }

      refreshGallery(variant);
      refreshPurchaseOptions(variant);
    }

    // Every option value that appears anywhere in the catalogue for this
    // product — the vocabulary the alt texts are matched against.
    var optionVocabulary = (function () {
      if (!variantData) return [];
      var seen = {};
      variantData.variants.forEach(function (v) {
        v.options.forEach(function (o) { if (o) seen[o.toLowerCase()] = true; });
      });
      return Object.keys(seen);
    })();

    function altGroup(button) {
      var alt = (button.getAttribute('data-alt') || '').toLowerCase();
      if (!alt) return null;
      // Longest match wins, so "Pistazie weiße Schokolade" is not read as
      // "Schokolade".
      var best = null;
      optionVocabulary.forEach(function (value) {
        if (alt.indexOf(value) !== -1 && (!best || value.length > best.length)) best = value;
      });
      return best;
    }

    function refreshGallery(variant) {
      var thumbs = document.querySelector('.pdp-gallery-thumbs');
      if (!thumbs || !variant) return;
      var buttons = Array.prototype.slice.call(thumbs.querySelectorAll('button'));
      var grouped = buttons.filter(function (b) { return altGroup(b); });

      var visible = buttons;
      if (grouped.length) {
        var selected = variant.options.map(function (o) { return (o || '').toLowerCase(); });
        visible = [];
        buttons.forEach(function (b) {
          var group = altGroup(b);
          // Ungrouped images are shared across flavours, so they always stay.
          var show = !group || selected.indexOf(group) !== -1;
          b.hidden = !show;
          if (show) visible.push(b);
        });
      }

      if (!visible.length) return;
      var target = variant.image && visible.filter(function (b) {
        return b.getAttribute('data-src') === variant.image;
      })[0];
      if (!target) target = visible[0];

      if (mainImage) mainImage.src = target.getAttribute('data-src');
      buttons.forEach(function (b) { b.classList.toggle('active', b === target); });
    }

    function onSelectionChange() {
      var values = selectedOptions();
      refreshPillAvailability(values);
      applyVariant(findVariant(values));
    }

    document.querySelectorAll('.pdp-pills').forEach(function (group) {
      group.querySelectorAll('.pdp-pill').forEach(function (b) {
        b.addEventListener('click', function () {
          // Unlinked sections still render plain pills with no variant
          // identity; keep the old cosmetic behaviour for those.
          if (!variantData) {
            if (b.classList.contains('soldout')) return;
            group.querySelectorAll('.pdp-pill').forEach(function (x) { x.classList.remove('active'); });
            b.classList.add('active');
            return;
          }
          group.querySelectorAll('.pdp-pill').forEach(function (x) { x.classList.remove('active'); });
          b.classList.add('active');
          onSelectionChange();
        });
      });
    });

    if (poGroup) {
      poGroup.querySelectorAll('.pdp-po-option').forEach(function (el) {
        el.addEventListener('click', function () { applyPurchaseOption(el); });
      });
    }

    if (variantData) onSelectionChange();

    // Social proof slider
    document.querySelectorAll('.pdp-sp-slider').forEach(function (slider) {
      var track = slider.querySelector('.pdp-sp-track');
      var prev = slider.querySelector('.pdp-sp-prev');
      var next = slider.querySelector('.pdp-sp-next');
      if (!track) return;
      function step() {
        var slide = track.querySelector('.pdp-sp-slide');
        if (!slide) return track.clientWidth * 0.5;
        var style = window.getComputedStyle(track);
        var gap = parseInt(style.columnGap || style.gap || '16', 10);
        return slide.getBoundingClientRect().width + gap;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    });

    // Qty
    document.querySelectorAll('.pdp-qty').forEach(function (qty) {
      var input = qty.querySelector('input');
      qty.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var d = parseInt(b.getAttribute('data-delta') || '0', 10);
          input.value = Math.max(1, parseInt(input.value || '1', 10) + d);
        });
      });
    });

    // Upsell checkbox: add the linked variant alongside the main product.
    // The checkbox used to be decorative only, so a checked upsell never
    // reached the cart.
    var buyForm = atcButton && atcButton.closest('form');
    var upsellInput = document.getElementById('pdp-upsell');
    if (buyForm && upsellInput) {
      buyForm.addEventListener('submit', function (event) {
        if (!upsellInput.checked || upsellInput.disabled) return;
        var upsellId = parseInt(upsellInput.getAttribute('data-variant-id') || '', 10);
        var mainId = variantInput ? parseInt(variantInput.value || '', 10) : NaN;
        if (!upsellId || !mainId) return;

        event.preventDefault();
        var qtyEl = document.getElementById('pdp-qtyInput');
        var qty = Math.max(1, parseInt((qtyEl && qtyEl.value) || '1', 10));
        var items = [{ id: mainId, quantity: qty }];
        var plan = planInput && planInput.value ? planInput.value : '';
        if (plan) items[0].selling_plan = parseInt(plan, 10) || plan;
        items.push({ id: upsellId, quantity: 1 });

        if (atcButton) atcButton.disabled = true;
        fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root + 'cart/add.js'
          : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (res) {
            if (!res.ok) return res.json().then(function (err) { throw err; });
            window.location.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
              ? window.Shopify.routes.root + 'cart'
              : '/cart');
          })
          .catch(function () {
            if (atcButton) {
              atcButton.disabled = false;
              atcButton.textContent = atcButton.getAttribute('data-label-available') || atcButton.textContent;
            }
            buyForm.submit();
          });
      });
    }
  });
})();
